import type { ReactElement } from 'react';

import type { CurrencyISO } from '@/constants/currencies';
import { formatterCurrency } from '@/utilities/format';
import { cn } from '@simplywallst/ui-core/next';

export interface Props {
  currencyISO: CurrencyISO;
  icon: ReactElement;
  value: number | null;
  isSelected?: boolean;
}

export const FairValue = ({ currencyISO, icon, value, isSelected }: Props) => {
  return (
    <>
      <div
        className={cn(
          'grid size-x3 place-content-center rounded-x3 bg-surface-2'
        )}
      >
        {icon}
      </div>
      <span
        className={cn('text-xs', isSelected ? 'text-solid' : 'text-softer')}
      >
        {formatterCurrency(value, currencyISO)}
        <span className="sr-only">Fair Value</span>
      </span>
    </>
  );
};
